<form class="flex flex-col gap-6" (submit)="submit($event)">
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      Let's find your <span class="text-primary">agency</span>
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Enter your agency's website and we'll set up your SHOUT workspace in seconds. No account needed yet.</p>
  </div>

  <div class="flex flex-col gap-2">
    <label for="vfa-website" class="text-base font-bold">Agency website</label>
    <div class="flex h-14 overflow-hidden rounded-lg border border-border focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20" [class.border-red-600]="onboarding.error()">
      <p class="m-0 flex items-center border-r border-border bg-muted px-4 text-lg font-semibold text-muted-foreground">https://</p>
      <input
        id="vfa-website"
        type="text"
        inputmode="url"
        autocomplete="url"
        autocapitalize="none"
        spellcheck="false"
        placeholder="youragency.com"
        class="min-w-0 flex-1 bg-card px-4 text-lg text-foreground outline-none placeholder:text-muted-foreground"
        [value]="onboarding.draft().url"
        (input)="onUrl($event)" />
    </div>
    @if (onboarding.error()) {
      <p class="m-0 text-base font-semibold text-red-600 dark:text-red-400" role="alert">{{ onboarding.error() }}</p>
    }
    @if (suggestions(); as agencies) {
      @if (agencies.length > 0) {
        <ul class="m-0 flex list-none flex-col gap-1 p-0">
          @for (agency of agencies; track agency.brandId) {
            <li>
              <button
                type="button"
                class="flex w-full items-center gap-3 rounded-lg border border-border px-3 py-2 text-left hover:border-primary/40 hover:bg-primary/5"
                (click)="select(agency)">
                @if (agency.icon) {
                  <img [src]="agency.icon" alt="" class="size-8 shrink-0 rounded-md bg-muted object-cover" />
                } @else {
                  <span class="size-8 shrink-0 rounded-md bg-muted" aria-hidden="true"></span>
                }
                <div class="min-w-0 flex-1">
                  <p class="m-0 truncate text-sm font-bold">{{ agency.name }}</p>
                  <p class="m-0 truncate text-sm text-muted-foreground">{{ agency.domain }}</p>
                </div>
              </button>
            </li>
          }
        </ul>
      }
    }
  </div>

  <button type="button" class="self-start text-lg font-bold text-primary hover:text-primary/80" (click)="manual()">
    No website? Enter details manually
  </button>

  <p class="m-0 text-base font-semibold text-muted-foreground">Trusted by teams at Adobe, BYD, GOLIN, Pizza Hut and monday.com</p>

  <div class="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background px-5 py-3 sm:static sm:z-auto sm:border-0 sm:bg-transparent sm:p-0">
    <button type="submit" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" [disabled]="onboarding.finding()">
      @if (onboarding.finding()) {
        <span class="size-4 animate-spin rounded-full border-2 border-white/40 border-t-white" aria-hidden="true"></span>
        Analysing {{ domain() || 'your site' }}…
      } @else {
        Find my agency →
      }
    </button>
  </div>
</form>
